module.exports = __webpack_public_path__ + "static/airqualitybt/images/usembassyPm2p5.jpg";